import type { PermissionsMap } from "@/lib/api";
import type { User } from "@/types";

/** Features del grupo Atlas: quien tiene alguna aterriza en el dashboard global. */
const ATLAS_FEATURES = ["agents", "workflow", "knowledge"];

/** Departamentos con dashboard propio, por slug, y su ruta. */
export const DEPARTMENT_HOME: Record<string, string> = {
  advertising: "/advertising",
  "pr-events": "/pr-events",
  "media-hub": "/media-hub",
  editorial: "/editorial",
};

export function isSuperAdmin(user: User | null | undefined): boolean {
  return (
    user?.isPlatformAdmin === true ||
    (user?.roles ?? []).some((r) => r.role?.name === "SUPER_ADMIN")
  );
}

/** Slugs de los departamentos a los que pertenece la persona. */
export function departmentSlugs(user: User | null | undefined): string[] {
  return (user?.departments ?? []).map((d) => d.department.slug);
}

/**
 * Ruta de aterrizaje tras el login.
 *
 * - Superadministrador o alguien con acceso a Atlas (agentes, flujo,
 *   conocimiento): el dashboard global, que es operativo.
 * - Si no, el dashboard del primer departamento suyo (en Editorial, sólo
 *   si puede ver las notas de prensa, que es lo que enseña).
 * - En último caso, el dashboard global.
 */
export function getLandingRoute(
  permissions: PermissionsMap | undefined,
  user?: User | null,
): string {
  if (isSuperAdmin(user)) return "/atlas";
  const canView = (feature: string) => permissions?.[feature]?.canView === true;
  if (ATLAS_FEATURES.some(canView)) return "/atlas";
  for (const slug of departmentSlugs(user)) {
    const home = DEPARTMENT_HOME[slug];
    if (home && (slug !== "editorial" || canView("press-releases"))) return home;
  }
  return "/atlas";
}
